import { motion, useScroll, useSpring } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CHECKOUT_URL } from "../config";

export default function Header() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });

  return (
    <header
      data-testid="nav-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ink/70 border-b border-cream/10"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display font-extrabold tracking-tight text-lg"
        >
          BLUEPRINT<span className="text-lime">™</span>
        </a>
        <p className="hidden md:block font-mono text-[10px] tracking-[0.3em] uppercase text-fog">
          A Dasha Love Experience
        </p>
        <a
          data-testid="header-cta-button"
          href={CHECKOUT_URL}
          className="group inline-flex items-center gap-1.5 bg-lime text-ink font-mono text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.14em] px-3 sm:px-4 py-2 whitespace-nowrap transition-colors duration-300 hover:bg-cream"
        >
          $111 — Get Access
          <ArrowUpRight
            size={14}
            className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </a>
      </div>
      <motion.div style={{ scaleX }} className="h-px bg-lime origin-left" />
    </header>
  );
}
